import { render, staticRenderFns } from "./QuotationTable.vue?vue&type=template&id=1c7e106b&scoped=true&"
import script from "./QuotationTable.vue?vue&type=script&lang=js&"
export * from "./QuotationTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationTable.vue?vue&type=style&index=0&id=1c7e106b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e106b",
  null
  
)

export default component.exports